<script setup lang="ts">
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue'
import MmToastView from '../base/MmToastView.vue'
import type { MmIconName } from '../base/icons'
const emit = defineEmits<{ resize: [height: number] }>()
const stack = ref<HTMLElement | null>(null)
const messages = ref<{ id: number; message: string; type: 'mint' | 'warn' | 'err'; icon: MmIconName }[]>([])
const timers = new Set<ReturnType<typeof setTimeout>>()
let sequence = 0, observer: ResizeObserver | undefined
const receive = async (event: Event) => {
  const { message, type, duration = 3000, icon } = (event as CustomEvent).detail || {}
  if (!message) return
  const id = ++sequence
  messages.value.push({ id, message, type: type === 'error' ? 'err' : type === 'warning' ? 'warn' : 'mint', icon: icon || (type === 'error' ? 'alert' : type === 'warning' ? 'clock' : 'check') })
  const timer = setTimeout(() => { messages.value = messages.value.filter(item => item.id !== id); timers.delete(timer) }, duration)
  timers.add(timer)
  await nextTick()
  emit('resize', stack.value?.offsetHeight || 0)
}
onMounted(() => {
  window.addEventListener('show-toast', receive)
  observer = new ResizeObserver(() => emit('resize', stack.value?.offsetHeight || 0))
  if (stack.value) observer.observe(stack.value)
})
onBeforeUnmount(() => {
  window.removeEventListener('show-toast', receive)
  timers.forEach(clearTimeout); observer?.disconnect(); emit('resize', 0)
})
</script>
<template><Teleport to="body"><div class="mm-root mm-overlay-root"><div ref="stack" class="toasts" aria-live="polite"><MmToastView v-for="item in messages" :key="item.id" :message="item.message" :type="item.type" :icon="item.icon" /></div></div></Teleport></template>
